import axiosInstance from "../../config/axiosInstance";

const getCompanySettings = () => {
  const response = axiosInstance.dillApi().get("companies/config");
  return response;
};

export default getCompanySettings;
